import React from 'react';
import WizardModalContent from './shared/WizardModalContent';
import cs from 'classnames'
import styles from './ClaimWizard.scss'
import i18n from 'lib/i18n'
import { disableRiskAndQualificationFields, missingWizardDocuments, updatedFormValue } from "./claimsWizardService"

// variables out of module
const _ = i18n('claimWizard')

const ClaimWizardStepFour = (props) => {

    const { claimDocumentsOptions, missingInfo, involvedPartiesData, involvedParties, formData, clientOptionsDict, documentFiles, oraDocuments, docsFromDocumentation } = props

    const getDocumentLabel = (docType) => {
        const index = claimDocumentsOptions.findIndex(oneOption => oneOption.value === docType)
        if (index === -1) {
            return docType
        }
        return claimDocumentsOptions[index].label
    }

    /**
     * Get a list of unfinished DS package files that are required for the wizard and have not been uploaded
     */
    const unfinishedDsPackageFiles = documentFiles.filter(file => file.dsPackageStatus && file.dsPackageStatus !== 'packageStatusFinished' && !file.uploaded &&
        oraDocuments.find(doc => doc.required === 'Wizard' && (doc.docType === file.docType || doc.alternativeDocTypes.some(altDoc => altDoc.altDocType === file.docType)))
    )


    const missingInvolvedPartiesInfo = () => {
        const missingInfoMessages = []

        if (involvedParties && involvedParties.length > 0) {
            involvedParties.forEach(party => {
                const partyIndex = involvedPartiesData.findIndex(p => p.partyNumber === party.partyNumber)
                const errorData = {
                    partyNumber: '',
                    label: '',
                    errorMessages: []
                }

                if (partyIndex > -1) {
                    const partyData = involvedPartiesData[partyIndex]
                    if (party.requiredFields && party.requiredFields.length > 0) {
                        party.requiredFields.forEach(field => {
                            switch (field) {
                                case 'Name':
                                    if (!partyData.fields.lastName.value || partyData.fields.lastName.value === '') {
                                        errorData.errorMessages.push(`${_('missingInfoMessage')} ${_('lastName')}`)
                                    }
                                    break;
                                case 'Mail':
                                    if (!partyData.fields.email.value || partyData.fields.email.value === '') {
                                        errorData.errorMessages.push(`${_('missingInfoMessage')} ${_('email')}`)
                                    }
                                    break;
                                case 'Phone':
                                    if (!partyData.fields.phoneNumber.value || partyData.fields.phoneNumber.value === '') {
                                        errorData.errorMessages.push(`${_('missingInfoMessage')} ${_('phone')}`)
                                    }
                                    break;
                                case 'Address':
                                    const addressFields = ['street', 'number', 'postalCode', 'town', 'country']
                                    for (const addressField of addressFields) {
                                        if (!partyData.fields[addressField].value || partyData.fields[addressField].value === '') {
                                            errorData.errorMessages.push(`${_('missingInfoMessage')} ${_(addressField)}`)
                                        }
                                    }
                                    break;
                                default:
                                    break;
                            }
                        })
                    }
                }
                if (errorData.errorMessages.length > 0) {
                    errorData.partyNumber = party.partyNumber
                    missingInfoMessages.push(errorData)
                }
            })

        }
        return missingInfoMessages

    }

    return (
        <WizardModalContent modalTitle={_('stepFourTitle')}>
            <form method="post" onSubmit={(ev) => ev.preventDefault()} className={styles.modalFormContent} key={"claimWizardStepFourForm"}>
                <div className={styles.sectionWrapper}>

                    <div className={styles.formInputContainer} >
                        <div className={styles.titleLabel}>{_('stepFourSubTitle')}</div>
                    </div>
                </div>
                <div className={styles.sectionWrapper}>
                    {/* <div className={styles.formInput}> */}
                    {/* <div className={styles.commentWrapper}>*/}
                    <div className={styles.stepFourComment}>
                        <textarea
                            name="claimComment"
                            {...formData.claimComment}
                        />
                    </div>
                </div>

                {(missingInfo && missingInfo.involvedParties && missingInfo.involvedParties.length > 0) &&
                    <div className={styles.sectionWrapper}>
                        <div className={styles.missingInfoWrapper} >
                            <div className={styles.missingInfoTitle}>{_('missingInvolvedPartiesData')}</div>

                        </div>
                        {missingInvolvedPartiesInfo().map((party, index) => {
                            return (
                                <div key={index} className={styles.missingInfoWrapper}>
                                    <div className={styles.missingInfoSubtitle}>{`${clientOptionsDict.involvedParties.find(i => i.value === party.partyNumber).label}`}</div>
                                    <div >
                                        {party.errorMessages.map((message, index) => {
                                            return (
                                                <div key={index} className={styles.missingInfo}>{message}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )

                        })}
                    </div>
                }
                {missingWizardDocuments(missingInfo, oraDocuments, docsFromDocumentation, documentFiles) && missingWizardDocuments(missingInfo, oraDocuments, docsFromDocumentation, documentFiles).length > 0 &&
                    <div className={styles.sectionWrapper}>
                        <div className={styles.missingInfoWrapper} >
                            <div className={styles.missingInfoTitle}>{_('missingDocuments')}</div>
                        </div>
                        {missingWizardDocuments(missingInfo, oraDocuments, docsFromDocumentation, documentFiles).map((doc, index) => {
                            return (
                                <div key={index} className={styles.missingInfoWrapper}>
                                    <div className={styles.missingInfo}>{`${getDocumentLabel(doc)}`}</div>
                                </div>
                            )

                        })}
                    </div>
                }
                {(unfinishedDsPackageFiles && unfinishedDsPackageFiles.length > 0) &&
                    <div className={styles.sectionWrapper}>
                        <div className={styles.missingInfoWrapper} >
                            <div className={styles.missingInfoTitle}>{_('unfinishedDsDocuments')}</div>
                        </div>
                        {unfinishedDsPackageFiles.map((doc, index) => {
                            return (
                                <div key={index} className={styles.missingInfoWrapper}>
                                    <div className={styles.missingInfo}>{`${doc.name}`}</div>
                                    {/* <div className={styles.missingInfo}>{`${getDocumentLabel(doc.docType)}`}</div> */}
                                </div>
                            )

                        })}
                    </div>
                }

                {props.children}
            </form>
        </WizardModalContent>
    );
};

export default ClaimWizardStepFour;


// WEBPACK FOOTER //
// ./components/ClaimsWizard/ClaimWizardStepFour.js